import React, {useState} from "react";
import {Modal} from "react-bootstrap";
import {LoadingButton} from "@commons/ui/component/Loading";

export let useConfirmationModalControls = () => {
    let [isVisible, setIsVisible] = useState(false)

    return {
        isVisible,
        setIsVisible,

        show: () => setIsVisible(true),
        hide: () => setIsVisible(false)
    }
}

export let confirmationModalControls = (state, setState) => {
    return {
        isVisible: state,
        setIsVisible: setState,

        show: () => setState(true),
        hide: () => setState(false)
    }
}

export let ConfirmationModal = ({
                                    title,
                                    hideHeader = false,
                                    body,
                                    showCloseButton = false,
                                    closeButtonText,
                                    buttonText,
                                    buttonTheme,
                                    buttonIcon,
                                    showProceedButton = true,
                                    onProceed,
                                    onHide = () => {
                                    },
                                    controls,
                                    modalProps,
                                    error,
                                    size = 'md',
                                    footerClassName = '',
                                    footerStartContent = <></>,
                                    staticBackdrop = true, // or 'static'
                                }) => {
    let [isLoading, setIsLoading] = useState(false)

    let _onProceed = () => {
        setIsLoading(true)
        let result = onProceed(() => controls.hide())
        if (!result) {
            setIsLoading(false)
            return
        }

        result.then(() => controls.hide())
            .finally(() => setIsLoading(false))
    }
    let onHideInternal = () => {
        onHide()
        controls.hide()
    }

    return <Modal show={controls.isVisible}
                  onExit={onHideInternal}
                  onHide={onHideInternal}
                  animation={true}
                  backdrop={staticBackdrop}
                  {...modalProps}
                  size={size}>
        {!hideHeader && <Modal.Header closeButton>
            <Modal.Title>{title}</Modal.Title>
        </Modal.Header>}
        {body && <Modal.Body>
            {body}
        </Modal.Body>}
        <Modal.Footer className={"flex-column align-items-end"}>
            {error && <div class={"text-danger mb-2"}>
                {error}
            </div>}
            <div className={footerClassName}>
                {showCloseButton && <button className={"btn btn-secondary"} onClick={onHideInternal}>
                    {closeButtonText}
                </button>}
                {footerStartContent}
                {showProceedButton &&
                    <LoadingButton isLoading={isLoading} className={`btn btn-${buttonTheme} ms-2`} onClick={_onProceed}>
                        {buttonIcon && <i className={`ai ai-${buttonIcon} me-2`}/>}
                        {buttonText}
                    </LoadingButton>}
            </div>
        </Modal.Footer>
    </Modal>
}